import { render, staticRenderFns } from "./contradictionCreate.vue?vue&type=template&id=7aab6202&"
import script from "./contradictionCreate.vue?vue&type=script&lang=js&"
export * from "./contradictionCreate.vue?vue&type=script&lang=js&"
import style0 from "./contradictionCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports